import React from 'react'

// 🔴 PART 15c — THE MARK IN THE BAR IS THIS SITE'S OWN FAVICON.
//
// George, 24 September 2026, verbatim: *"making sure the favicon is the same icon used in the
// header"*. Until today the bar drew the shared five-circle family glyph while the favicon was
// this site's own two-card drawing — two different pictures for one site, which is the fault the
// rule names. The bar now draws the favicon's own drawing, so the tab, the bookmark and the
// header are ONE icon. Part 3's construction is unchanged (full width, sticky, this site's own
// near-black at 0.82 through a blur, the hairline underneath, the label over
// NODEJAVASCRIPT.COM); only the GLYPH is the site's own.
//
// It is drawn ONCE here and used TWICE — the header bar and the footer's brand line — so the two
// can never drift into two different marks.
//
// 🔴 THE GEOMETRY IS THE FAVICON'S, VERBATIM — DO NOT "TIDY" THE NUMBERS. Part 15c is measured,
// by `svg_sig()` in `~/.nodejs_compliance.py`, from the RENDERED page: it compares this drawing
// with `public/favicon.svg` shape by shape — a circle by its centre, a rect and a path by their
// own commands — so a rounded coordinate, a rescaled rect or an added `fill` is a DIFFERENT
// drawing to that check. The frame and the two cards are the mark itself and are all kept; the
// only omission is the favicon's background plate, because the bar is that kind of ground.
const Mark = ({ size = 22 }) => (
  <svg viewBox='0 0 64 64' width={size} height={size}>
    <rect x='12' y='12' width='40' height='40' rx='6' fill='none' stroke='#34d399' strokeWidth='3' />
    <path d='M32 18l9 10h-5.5v8h-7v-8H23z' fill='#34d399' />
    <path d='M32 46l-9-10h5.5v-8h7v8H41z' fill='#6ee7b7' />
  </svg>
)

export default Mark
